<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight my-content">
        <!-- 选项卡[[ -->
        <div class="g-tab">
            <a href="javascript:;" v-for="(item,index) in tabList" :key="index">
                <div class="g-tab-item g-tab-item-active">{{item.name}}</div>
            </a>
        </div>
        <!-- 选项卡]] -->
        <div>
        <div class="my-content-tabs my-content-1">
            <!-- 未参与，待达标 选项[[ -->
            <div class="search searchs f-clearfix">
            <!--<div class="search search f-clearfix f-hide">-->
                <select-box :selectList="allGame" :itemTitle="'游戏'" :selected.sync="params.gameId"></select-box>
                <select-box
                        :selectList="getArticleTypeList"
                        :itemTitle="'内容类型'"
                        :selected.sync="params.type"
                        :placeholder="'请选择内容类型'">

                </select-box>

                <select-box
                        :selectList="articleStatusList" :itemTitle="'同步状态'"
                            :selected.sync="params.status"
                            :placeholder="'请选择同步状态'">
                </select-box>
                <div class="list list-title">
                <!--<div class="list">-->
                    <p class="name"><label for="keyword">内容标题</label></p>
                    <div class="g-select f-fl">
                        <input class="input"
                               name="keyword"
                               type="text"
                               placeholder="请输入要搜索的内容标题"
                               v-model.trim="params.title"
                        >
                    </div>
                </div>
                <div class="inquire">
                    <input class="btn" type="button" value="查询" @click="queryArticleList">
                </div>
            </div>

            <ul class="freelance-list normal">
                <li class="list-empty f-clearfix" v-if="!articleList.length">
                    <img src="~Assets/img/pages/v4/search-null.png"/>
                </li>
                <li class="list" v-for="article in articleList" :key="article.id">
                    <div class="f-clearfix">
                        <p class="pic f-fl" @click="preview(article)" style="cursor: pointer">
                            <img class="pic-img" :src="article.cover" alt="">
                        </p>
                        <div class="txt f-fl">
                            <h3 class="title">
                                <span class="type">{{ getArticleType(article) }}</span>
                                <a class="name f-hide-col-1 js-open-view" href="javascript:;" @click="preview(article)">{{ article.articleTitle }}</a>
                            </h3>
                            <div class="intro f-hide-col-1">
                                {{ getGame(article.gameId) }}
                            </div>
                            <div class="author">
                                <span class="time">{{ article.created ?  article.created.substr(0,10) : '' }}</span>
								<div class="vid-pop f-fr" v-if="article.vid">
									<span class="vid-pop-title">腾讯视频链接vid</span>
									<div class="vid-pop-cnt">
										<div class="tooltip-arrows-down"></div>
										<p>vid: {{article.vid}}</p>
										<p>链接: {{`https://v.qq.com/x/page/${article.vid}.html`}}</p>
									</div>
								</div>
                            </div>
                        </div>
                        <div class="examine f-fl">
                            <a class="switch js-down"
                               style="margin-right: 10px"
                               href="javascript:;"
                               @click="article.showMediaDistribute = !article.showMediaDistribute">
                                媒体账号
                                <i class="ico" :class="article.showMediaDistribute ? 'ico-up' : 'ico-down'"></i>
                            </a>
                        </div>

                        <div class="operation draft f-fl"> <!-- 0629修改 -->
                            <p class="status">
                                <span class="color-theme">
                                {{ getArticleStatusText(article.articleStatus)}}
                                </span>
                                <span v-if="article.articleStatus==50" :title="`驳回原因：${article.reject_remark}`" class="reject-remark">？</span>
                            </p>
                            <p class="btn f-clearfix">
                                <a class="g-btn" href="javascript:;" v-if="[0,10,25,20].includes(article.articleStatus)" @click="editArticle(article)">编辑</a>
                                <!-- <a class="g-btn f-fr" href="javascript:;" @click="publishArticle(article)">{{curTab ==0 ? '发布' : '投稿'}}</a> -->
                                <!-- <a class="g-btn preview-video" href="javascript:;" @click="preview(article)">预览</a> -->
                                <a class="g-btn js-open-reject" href="javascript:;" v-if="[0,10,50].includes(article.articleStatus)"  @click="deleteArticle(article)">删除</a>
                            </p>
                        </div>
                    </div>
                    <ul class="channel f-clearfix js-channel-show" style="display: block" v-if="article.showMediaDistribute">
                        <li class="item f-fl" v-for="media in article.media" :key="media">
                            <span class="head"><img :src="media.accountAvatar" width="25" height="25"></span>
                            <a class="name f-hide-col-1 js-open-channel" href="javascript:;" @click="showMediaDistributeDialog(media)">{{ media.accountName }}</a>
                            <span class="sync sync-success" v-if="media.status==1">同步<i class="ico ico-success"></i></span>
                            <span class="sync sync-failure" v-else-if="media.status==0" @keyup.enter="media.show=true">未同步 <i class="ico ico-notice"></i></span>
                            <span class="sync sync-failure" v-else-if="media.status==3">同步失败<i class="ico ico-failure"></i></span>
                            <div class="sync-failure-reason" style="display: block" v-if="media.show">
                                <div class="sync-failure-triangle"></div>
                                <div class="failure-reason-text f-hide-col-1">同步失败原因</div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!-- 分页[[ -->
        <pagination
                v-if="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager">
        </pagination>
        <!-- 分页]] -->
        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <media-distribute-info ref="mediaDistributeInfo"></media-distribute-info>
        <!--内容预览 end-->
        </div>
    </div>
    <!-- 右边主体]] -->
</template>
<script>
import pagination from 'Components/v4/pagination/pagination_v4';
import selectBox from 'Components/v4/dropdown/select_box';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import mediaDistributeInfo from '../order/supplier_order/media_distribute_info';
import {
    AllGame, ArticleDelete, ArticlesV3List
} from 'Services/getData.js';
export default {
    data() {
        return {
	            allGame: [],
	            articleType: [
		            {
                    name: '请选择', id: '' 
                },
                {
                    name: "图文", id: 0 
                },
                {
                    name: "视频", id: 1 
                },
                {
                    name: "小说", id: 50 
                },
                {
                    name: "漫画", id: 60 
                }
	            ],
	            tabList: [
                {
                    name: '任务内容', id: 4, isActive: false, eName: 'task', type: 7
                }
	            ],
	            params: {
		            gameId: '',
                type: '',
                title: '',
                demandItemType: '', // 1个人外团明细项2供应商作者订单，有订单id时必填
                demandItemId: '', // 明细项或作者订单id
                // status:'', // 内容同步状态 
                checkStatus: '', // ugc 验收状态
                status: '', // 代表全部
                page: 1,
                pageSize: 10
	            },
            articleStatusList: [
                {
                    name: '全部', id: ''
                },
                {
                    name: '草稿中', id: 0
                },
                {
                    name: '待审核', id: 10
                },
                {
                    name: '审核中', id: 25
                },
                {
                    name: '已通过', id: 20
                },
                {
                    name: '已发布', id: 30
                },
                {
                    name: '已驳回', id: 50
                },
                {
                    name: '已删除', id: 70
                }
            ],
            paginationConf: {
                	total: 0,
                pageSize: 10
            },
            articleList: [],
            articleStat: []
        }
    },
    components: {
        pagination, selectBox, contentPreview, videoPreview, mediaDistributeInfo

    },
    created() {

    },
    mounted(){
	        this.getAllGame();
	        this.getArticleList();
    },
    methods: {
        getTabId () {
            return this.$route.params.tabId ? parseInt(this.$route.params.tabId) : 0;
        },
	        getArticleList(){
            this.articleList = [];
            this.getArticlesV3List();
	        },
	        queryArticleList() {
		        this.params.page = 1;
		        this.getArticleList();
        },
	        pageChange (param) {
		        // this.params.pageSize = param.pageSize; // 发送给接口的字段
		        this.params.page = param.pageIndex; // 发送给接口的字段
		        this.getArticleList();
	        },
        preview(article){
            if(article.articleType === 0){
                this.$refs.contentPreview.loadV3Info(article.id);
            }else if(article.articleType){
                this.$refs.videoPreview.remoteV3Preview(article.id);
            }
        },
        editArticle(article){
            this.$router.push({
                name: 'v3-contribute', query: {
                    id: article.id
                }
            });
                
        },
	        publishArticle(article){
		        this.$router.history.push({
                name: 'v3-contribute', query: {
                    id: article.id
                }
            });
	        },
	        deleteArticle(article){
		        let self = this;
		        this.$confirm('确认删除此内容').then(()=>{
				    self.doDeleteArticle(article.id);
		        }).catch((e) => {
			        console.log(e);
            });
	        },
        async doDeleteArticle(id){
	            let res = await ArticleDelete(id);
	            if(res.status === 200 && res.data.code == 0){
		            this.$alert('删除成功');
	            }
	            this.getArticleList();
        },
        async getArticlesV3List(){
            let param = this.params;
	            let response = await ArticlesV3List(param);
           
            let result = response.data;
	            if(result.code == 0){
		            this.articleList = result.data.data.map((article)=>{
			            article.showMediaDistribute = false;
			            article.operation = {
			            	preview: true
                    }
			            return article;
                });
		            this.paginationConf.total = result.data.total;
	            }
                
        },
	        showMediaDistributeDialog(media){
		        this.$refs.mediaDistributeInfo.show(media);
	        },
	        async getAllGame(){
		        let res = await AllGame();
		        if(res.data && res.data.data.length){
			        this.allGame = res.data.data;
			        this.allGame.unshift({
                    id: 0, name: '全部'
                });
		        }
        },
        getGame(gameId){
            let res = this.allGame.filter(item => item.id == gameId)
            return res.length ? res[0].name : '';
        },
	        resetPageConf(){    // 初始化查询数据
		        this.params.page = 1;
	            this.params.checkStatus = '';

        },
	        getArticleType(item){
		        let type = '';
		        switch(parseInt(item.articleType)){
			        case 0:
				        type = '图文';
				        break;
			        case 1:
				        type = '视频';
				        break;
			        case 50:
				        type = '小说';
				        break;
			        case 60:
				        type = '漫画';
				        break;
			        default:
				        type = '其他';
				        break;
		        }
		        return `【${type}】`;
	        },
	        getArticleStatusText(status){
            let text = '';
            text = this.articleStatusList.filter(item => item.id === status)
		        return text.length ? text[0].name : '';
	        }
    },

    computed: {
        	getArticleTypeList() {
			    return this.articleType;
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/manage/content.scss';
    .my-content .freelance-list .operation .btn .g-btn{margin-bottom: 3px}
    .list-empty{
        width: 100%;
        text-align: center;
        height: 300px;
        margin-top: 50px;
    }
	.filter-draft-active{cursor: auto}
	.ico-notice{
		vertical-align: -2px;
	}
    .js-open-reject{margin-left: 5px}
    .operation{
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        flex-direction: column;
    }
    .reject-remark{cursor: pointer;color: #FD7E28}
    .my-content .search {
        padding: 0 0 20px;
    }
</style>